import { render, staticRenderFns } from "./TermoAtualizacao.vue?vue&type=template&id=52214171"
import script from "./TermoAtualizacao.vue?vue&type=script&lang=js"
export * from "./TermoAtualizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports